import { useMemo } from 'react';
import { getSelectedAccountInfo } from '@ibk/shared-auth';
import { useCnpjAlphanumeric } from '@ibk/shared-ui';
import { formatPixKeyAlphanumeric, PixType } from '../../utils/formatPixKey';
export function useUserTaxIdentifier() {
    const { isValidCnpj, maskCnpj, unmaskCnpj } = useCnpjAlphanumeric();
    const userTaxIdentifier = useMemo(() => {
        const accountInfo = getSelectedAccountInfo();
        const documentNumber = accountInfo?.documentNumber;
        if (!documentNumber) {
            return '';
        }
        return formatPixKeyAlphanumeric(documentNumber, PixType.TAX_IDENTIFIER, {
            isValidCnpj,
            maskCnpj,
            unmaskCnpj,
        });
    }, [isValidCnpj, maskCnpj, unmaskCnpj]);
    return {
        userTaxIdentifier,
    };
}
